module.exports = __webpack_public_path__ + "static/media/type.5b97ff42.svg";